import { valid, parse } from './bi-parsers';

export const Categories = {
  EDITOR: 1,
  VIEWER: 2,
  TIMEOUTS: 3,
  SERVER: 4,
};

let disabled = false;

export function disableBiSend() {
  disabled = true;
}

const _initOptions = {
  // The BI server's hostname
  hostName: 'frog.wix.com',

  // The BI server URL
  biUrl: '//frog.wix.com/',

  // error output stream
  error(str) {
    console.error(str); // eslint-disable-line no-console
  },

  sendInvalidEvents: true,
};

function _extend(dst) {
  for (let i = 1; i < arguments.length; i += 1) {
    const extending = arguments[i];
    if (extending) {
      for (const key in extending) {
        if (extending.hasOwnProperty(key)) {
          dst[key] = extending[key];
        }
      }
    }
  }
  return dst;
}

const _options = _extend({}, _initOptions);

export function event(eventParams) {
  const _biFieldsRestrictions = {
    src: { type: 'number' },
    evid: { type: 'number' },
  };

  return new Promise((resolve, reject) => {
    if (
      !validateBiEventArgs(eventParams, ['evid'], _biFieldsRestrictions) &&
      !_options.sendInvalidEvents
    ) {
      reject('Event is invalid');
      return;
    }
    sendBiEvent(eventParams, resolve);
  });
}

export function validateBiEventArgs(eventArgs, requiredArgs, restrictions, id) {
  const missingRequiredArgs = requiredArgs.slice(0);
  for (const key in eventArgs) {
    if (eventArgs.hasOwnProperty(key)) {
      // validate & parse the key
      const currentRestrictions = restrictions[key] || {};

      eventArgs[key] = parse(eventArgs[key], currentRestrictions);
      if (!valid(eventArgs[key], currentRestrictions)) {
        _options.error(
          [
            `\t${id}. Bad event param (key: ${key}, value: ${JSON.stringify(
              eventArgs[key],
            )})`,
            `\tCurrent restrictions: ${JSON.stringify(restrictions[key])}\n`,
          ].join('\n'),
        );
        return;
      }

      // remove the key from the required fields
      const missingIndex = missingRequiredArgs.indexOf(key);
      if (missingIndex > -1) {
        missingRequiredArgs.splice(missingIndex, 1);
      }
    }
  }

  if (missingRequiredArgs.length > 0) {
    _options.error(
      `Missing required params: ${missingRequiredArgs.join(', ')}`,
    );
    return false;
  }

  return true;
}

function addUrlParams(url, params) {
  const delimiter = url.match(/\?./) ? '&' : '?';
  return (
    url.replace(/\?$/, '') +
    delimiter +
    _(params)
      .keys()
      .filter(function(key) {
        return !_.isUndefined(params[key]);
      })
      .map(function(key) {
        return [
          encodeURIComponent(key),
          '=',
          encodeURIComponent(params[key]),
        ].join('');
      })
      .join('&')
  );
}

function sendBiEvent({ adapter = '', ...eventArgs }, onComplete = _.noop) {
  if (disabled) {
    onComplete(_options.biUrl);
    return;
  }
  const url = addUrlParams(_options.biUrl + adapter, eventArgs);

  // The magic line
  const biImage = new Image(0, 0);
  biImage.onload = onComplete;
  biImage.onerror = onComplete;
  biImage.src = url;
}
